/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * 仅仅共 dpub 相关页面使用请勿在其他项目使用
 * by yanchaoren
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */
import shortid from 'shortid'
import query from '../util/query'
const Omega = window.Omega

// 简版的生成唯一id的方法，用于兼容shortid库在某些机型上报错的情况
function makeid () {
  let text = ''
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < 9; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

let timer // 心跳埋点的定时器

const onlineEventId = 'dpub_track'

class OmegaStats {
  constructor (queryObj) {
    this.pid = 0
    this.lock = false
    this.shareUrl = window.location.href
    this.attrs = {}
    this.addLeave = false
    // dchnArr 有可能是数组（[wx,wx2]）取出第一项
    const dchnArr = queryObj.dchn
    this.dchn = dchnArr && dchnArr.split(',')[0].replace('[', '')
    // 初始化分享层级
    this._initShareLevel(queryObj)
  }

  setOmega (config) {
    Omega.setConfig(config)
  }

  setTelephone (Telephone) {
    Omega.setTelephone(Telephone)
  }

  /**
   * 初始化分享层级
   * @param {*} queryObj
   */
  _initShareLevel (queryObj) {
    const shareInfoFromPath = queryObj.pid
    try {
      this.pageId = shortid.generate()
    } catch (e) {
      this.pageId = makeid()
    }

    if (!shareInfoFromPath || !/\d_.+/.test(shareInfoFromPath)) {
      this.parentLevel = 0
      this.currentLevel = 1
      this.parentId = ''
    } else {
      this.parentLevel = +shareInfoFromPath.split('_')[0]
      this.currentLevel = this.parentLevel + 1
      this.parentId = shareInfoFromPath.split('_')[1]
    }
  }

  /**
   * Telephone 和 appKey由页面设置 stop pause slp resume 没有调用暂时不用实现
   *
   * @param {*} config
   * @memberof OmegaStats
   */
  setConfig (config) {
    const queryObj = query.query()
    // 设置下分享层级
    this._initShareLevel(queryObj)
    this.pid = config.project.id
    this.shareUrl = this.getShareUrl()
    this.addLeave = true
    // 发送PV 埋点
    this.send('view')
    const isCmb = /MPBank\//i.test(window.navigator.userAgent)
    if (isCmb) {
      return
    }
    // 开始心跳埋点
    startHeartbeat()
    // 发送渠道信息
    this.dchn && this.startDCHN(config.project)
  }

  getShareUrl (link) {
    /**
     * 如果已经 增加了分享层级并且没有传入 分享url 则 直接返回上次的分享链接，修复N次调用getShareUrl 分享层级+N
     * * */
    if (this.addLeave && !link) return this.shareUrl
    /**
     * link: 需要添加参数的链接
     *  link默认是当前的location.href，若有值，则分享的可能不是当前页面，没有必要覆盖shareUrl
     */
    let shareUrl = link || window.location.href
    const { params } = query.decode(shareUrl)
    const hasPidInPath = !!params.pid
    if (hasPidInPath) {
      this.currentLevel = +params.pid.replace(/_.+/, '')

      shareUrl = query.build(shareUrl, {
        pid: `${this.currentLevel + 1}_${this.pageId}`
      })
    } else {
      shareUrl = query.build(shareUrl, {
        pid: `${this.currentLevel + 1}_${this.pageId}`
      })
    }

    if (!link) {
      this.shareUrl = shareUrl
    }
    return shareUrl
  }

  send (type, params) {
    if (this.lock) {
      return
    }

    let defaultConfig = {
      ...query.getPassQuery(),
      pid: this.pid,
      pageid: this.pageId
    }
    // 有渠道则添加渠道
    if (this.dchn) {
      defaultConfig.dchn = this.dchn
    }

    switch (type) {
    case 'view':
      defaultConfig = {
        ...defaultConfig,
        id: 'dpub-view',
        label: '页面浏览，分享链路',
        type: 'view',
        level: this.currentLevel,
        parent: this.parentId
      }
      break
    case 'action':
      defaultConfig = {
        ...defaultConfig,
        label: '行为埋点',
        type: 'action'
      }
      break
    case 'custom':
      defaultConfig = {
        ...defaultConfig,
        label: '自定义事件',
        type: 'custom'
      }
      break
    case 'heartbeat':
      // 心跳埋点不希望被记录到自定义埋点中，所以这里label必须为空
      defaultConfig = {
        ...defaultConfig,
        id: 'heartbeat',
        label: '',
        type: 'heartbeat'
      }
      break
    case 'dchn':
      defaultConfig = {
        ...defaultConfig,
        id: 'dchn',
        label: '渠道埋点',
        type: 'dchn'
      }
      break
    default:
      defaultConfig = {
        ...defaultConfig,
        type: type
      }
    }
    defaultConfig = {
      ...defaultConfig,
      ...params
    }
    window.Omega.trackEvent(onlineEventId, defaultConfig.label, defaultConfig)
  }

  startDCHN (project) {
    // 渠道埋点，临时的渠道实时数据查看方案
    const channelMap = (project.ext && project.ext.customerChannels) || {}
    this.send('dchn', {
      label: channelMap[this.dchn] || this.dchn
    })
  }
}

const queryObj = query.query()
const omegaStats = new OmegaStats(queryObj)
export default omegaStats

// 监听页面滚动
document.addEventListener(
  'DOMContentLoaded',
  function () {
    const parentDom = document.getElementById('root')
    const scrollHandler = function () {
      omegaStats.send('action', {
        id: 'root_scroll',
        cat: 'scroll',
        label: '页面滚动',
        ext: {}
      })
      parentDom && parentDom.removeEventListener('scroll', scrollHandler, false)
      document.removeEventListener('scroll', scrollHandler, false)
    }
    if (parentDom) {
      parentDom.addEventListener('scroll', scrollHandler, false)
    } else {
      document.addEventListener('scroll', scrollHandler, false)
    }
  },
  false
)

function startHeartbeat () {
  startTimer()
}

// 轮询定时器
const config = {
  count: 0,
  gap: 0,
  levelOneCountLimit: 30,
  levelOneGap: 2,
  durationLimit: 60 * 60
}
const gapList = [1, 1, 2, 3, 5, 8, 13, 21]
const gapLen = gapList.length
let circleIndex = 0
let duration = 0

function startTimer () {
  if (duration > config.durationLimit || omegaStats.lock) {
    // 大于1小时，清除计数器
    timer && clearTimeout(timer)
    return
  }
  if (config.count <= config.levelOneCountLimit && config.count > 0) {
    // 60s 内2秒钟发一次埋点
    config.gap = config.levelOneGap
  } else if (config.count > config.levelOneCountLimit) {
    config.gap = gapList[circleIndex]
    circleIndex++
    if (config.gap === gapList[gapLen - 1]) {
      // 到达21s后重置
      circleIndex = 0
    }
  }
  duration = duration + config.gap
  timer = window.setTimeout(() => {
    omegaStats.send('heartbeat', {
      id: 'heartbeat',
      ext: {
        count: config.count,
        gap: config.gap,
        duration
      }
    })
    timer && window.clearTimeout(timer)
    timer = null
    startTimer(config)
  }, config.gap * 1000)
  config.count++
}
